"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AD_FEED_SOURCE_KEYS = exports.AdFeedSource = void 0;
var AdFeedSource;
(function (AdFeedSource) {
    AdFeedSource["TrendingTopCategory"] = "TrendingTopCategory";
    AdFeedSource["TrendingSpecificCategory"] = "TrendingSpecificCategory";
    AdFeedSource["Competitor"] = "Competitor";
    AdFeedSource["GeneralTopCategory"] = "GeneralTopCategory";
    AdFeedSource["GeneralSpecificCategory"] = "GeneralSpecificCategory";
})(AdFeedSource || (exports.AdFeedSource = AdFeedSource = {}));
exports.AD_FEED_SOURCE_KEYS = [
    AdFeedSource.TrendingTopCategory,
    AdFeedSource.TrendingSpecificCategory,
    AdFeedSource.Competitor,
    AdFeedSource.GeneralTopCategory,
    AdFeedSource.GeneralSpecificCategory,
];
